import React, { useEffect, useState } from "react";
import {
    Box,
    FormControl,
    FormControlLabel,
    Grid,
    IconButton,
    InputAdornment,
    Paper,
    Radio,
    RadioGroup,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    tableCellClasses,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import SelectField from "components/Select";
import { PrimaryButton } from "components/Buttons";
import Colors from "assets/Style/Colors";
import { FontFamily } from "assets";
import { ErrorToaster, SuccessToaster } from "components/Toaster";
import InputField from "components/Input";
import DatePicker from "components/DatePicker";
import {
    getFileSize,
} from "utils";
import { Add } from "@mui/icons-material";
import styled from "@emotion/styled";
import UploadFile from "components/UploadFile";
import { v4 as uuidv4 } from "uuid";
import { CleanTypes } from "utils";
import instance from "config/axios";
import routes from "services/System/routes";
import { useAuth } from "context/UseContext";
import { emailRegex } from 'utils/index';
import InputPhone from "components/InputPhone";
import BuyerServices from "services/Buyer";
import { FiDownload } from "react-icons/fi";
import AuctionHouseServices from "services/AuctionHouse";
import DeleteIcon from '@mui/icons-material/Delete';
import { ContentCopy, Check, Visibility, VisibilityOff } from '@mui/icons-material';


// *For Table Style
const Row = styled(TableRow)(({ theme }) => ({
    border: 0,
}));

const Cell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        fontSize: 14,
        fontFamily: FontFamily.NunitoRegular,
        border: 0,
        textAlign: "left",
        whiteSpace: "nowrap",
        backgroundColor: Colors.primary,
        color: Colors.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        fontFamily: FontFamily.NunitoRegular,
        textAlign: "left",
        textWrap: "nowrap",

        ".MuiBox-root": {
            display: "flex",
            gap: "6px",
            alignItems: "center",
            justifyContent: "center",
            ".MuiBox-root": {
                cursor: "pointer",
            },
        },
        svg: {
            width: "auto",
            height: "24px",
        },
        ".MuiTypography-root": {
            textTransform: "capitalize",
            fontFamily: FontFamily.NunitoRegular,
            textWrap: "nowrap",
        },
        ".css-1ru1j9e-MuiTableCell-root ": {
            color: "#ffffff",
            textAlign: "left",

        },
        ".MuiButtonBase-root": {
            padding: "8px",
            width: "28px",
            height: "28px",
        },
    },
}));

const allowFilesType = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "application/pdf",
];

function UpdateCompany() {
    const navigate = useNavigate();
    const { id } = useParams();
    const { user, userLogout } = useAuth();

    const {
        register,
        handleSubmit,
        formState: { errors, dirtyFields },
        setValue,
        getValues,
        resetField,
        control,
    } = useForm();
    const [loading, setLoading] = useState(false);

    const [companyStatus, setCompanyStatus] = useState(null);
    const [showMasterPassword, setShowMasterPassword] = useState(false);
    const [showMasterrPassword, setShowMasterrPassword] = useState(false);

    const [showAuctionPassword, setShowAuctionPassword] = useState(false);

    const [companyExpiryDate, setCompanyExpiryDate] = useState(new Date());
    const [documentExpiryDate, setDocumentExpiryDate] = useState(new Date());

    const [progress, setProgress] = useState(0);
    const [uploadedSize, setUploadedSize] = useState(0);
    const [documentDetail, setDocumentDetail] = useState([]);
    const [documentLink, setDocumentLink] = useState("");
    const [fetching, setFetching] = useState(false);
    const [selectedIdType, setSelectedIdType] = useState(null);
    const [documentList, setDocumentList] = useState([]);
    const [orgId, setOrgId] = useState();

    const [companyData, setCompanyData] = useState([]);
    const [auctionHouses, setAuctionHouses] = useState([]);
    const [selectedAuctionHouses, setSelectedAuctionHouses] = useState(null);

    const [credAuctionHouse, setCredAuctionHouse] = useState(null);
    const [credMasterId, setCredMasterId] = useState("");
    const [credMasterEmail, setCredMasterEmail] = useState("");
    const [credMasterPassword, setCredMasterPassword] = useState("");
    const [credAuctionPassword, setCredAuctionPassword] = useState("");
    const [removedAuctionIds, setRemovedAuctionIds] = useState([]);


    const [auctionCredentials, setAuctionCredentials] = useState([]);

    const hasAuctionAlready = (auctionId) =>
        auctionCredentials.some(r => String(r.auction_id) === String(auctionId));

    const hasMasterIdAlready = (masterId) =>
        auctionCredentials.some(r => String(r.master_id) === String(masterId));

    const addAuctionCredential = () => {
        try {
            if (!credAuctionHouse?.id) return ErrorToaster("Please select an auction house.");
            if (!credMasterId) return ErrorToaster("Please enter Auction Master ID.");
            // if (!credMasterEmail) return ErrorToaster("Please enter Master Email.");
            if (!credAuctionPassword) return ErrorToaster("Please enter Auction Master Password.");

            if (hasAuctionAlready(credAuctionHouse?.id)) {
                return ErrorToaster(`${credAuctionHouse.name} is already added.`);
            }

            if (hasMasterIdAlready(credMasterId)) {
                return ErrorToaster(`MAster ID ${credMasterId} is already added.`);
            }

            setAuctionCredentials((prev) => [
                ...prev,
                {
                    id: uuidv4(),
                    auction: credAuctionHouse,
                    auction_id: credAuctionHouse.id,
                    master_id: credMasterId,
                    // master_email: credMasterEmail,
                    // master_password: credMasterPassword,
                    auction_password: credAuctionPassword || "",

                    showMaster: false,
                    showAuction: false,

                    canEditMaster: true,
                    canEditAuction: true,

                    _isNew: true,
                    _dirtyMaster: !!credMasterPassword,
                    _dirtyAuction: !!credAuctionPassword,
                },
            ]);

            setCredAuctionHouse(null);
            setCredMasterId("");
            setCredMasterEmail("");
            setCredMasterPassword("");
            setCredAuctionPassword("");
        } catch (e) {
            ErrorToaster(e);
        }
    };

    // const removeAuctionCredential = (rowId) => {
    //     setAuctionCredentials((prev) => prev.filter((x) => x.id !== rowId));
    // };

    const removeAuctionCredential = (rowId) => {
        setAuctionCredentials((prev) => {
            const row = prev.find((x) => x.id === rowId);

            if (row && !row._isNew && row.auction_id) {
                setRemovedAuctionIds((old) => {
                    const next = new Set(old);
                    next.add(Number(row.auction_id));
                    return Array.from(next);
                });
            }

            return prev.filter((x) => x.id !== rowId);
        });
    };



    const getAuctionHouses = async (search) => {
        try {
            let params = {
                page: 1,
                limit: 50,
                search: search
            }
            const { data } = await AuctionHouseServices.getAuctionHouses(params)
            setAuctionHouses(data?.auction_houses.rows)
        } catch (error) {
            ErrorToaster(error)
        }
    }

    const downloadAllAttachments = async (documentLinks) => {

        if (!documentLinks || documentLinks.trim() === "") {
            ErrorToaster("No attachments available.");
            return;
        }

        const filePath = documentLinks.trim();
        const fileUrl = `${process.env.REACT_APP_IMAGE_BASE_URL}${filePath}`;
        const fileExtension = filePath.split('.').pop();

        try {
            const response = await fetch(fileUrl);
            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = blobUrl;
            link.setAttribute("download", `attachment.${fileExtension}`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            window.URL.revokeObjectURL(blobUrl);
            SuccessToaster("Downloading attachment...");
        } catch (error) {
            console.error("Download failed", error);
            ErrorToaster("Failed to download attachment.");
        }
    };


    const IDTYPES = [
        { id: "passport", name: "Passport" },
        { id: "e-id", name: "E-ID" },
        { id: "tax-document", name: "Tax Document" },
        { id: "trade-license", name: "Trade License" },
    ];

    const handleCompanyExpiryDate = (newDate) => {
        try {
            if (newDate == "Invalid Date") {
                setCompanyExpiryDate("invalid");
                return;
            }
            setCompanyExpiryDate(new Date(newDate));
        } catch (error) {
            ErrorToaster(error);
        }
    };


    const handleDocumentExpiryDate = (newDate) => {
        try {
            if (newDate == "Invalid Date") {
                setDocumentExpiryDate("invalid");
                return;
            }
            setDocumentExpiryDate(new Date(newDate));
        } catch (error) {
            ErrorToaster(error);
        }
    };

    const handleUploadDocument = async (e) => {
        try {
            e.preventDefault();
            const file = e.target.files[0];
            let arr = [
                {
                    id: uuidv4(),
                    name: file?.name,
                    file: "",
                    type: file?.type.split("/")[1],
                    size: getFileSize(file.size),
                    isUpload: false,
                },
            ];
            if (allowFilesType.includes(file.type)) {
                setDocumentDetail(arr);
                handleUpload(file, arr);
            } else {
                ErrorToaster(`Only ${CleanTypes(allowFilesType)} formats is supported`);
            }
        } catch (error) {
            ErrorToaster(error);
        }
    };

    const handleUpload = async (file, docs) => {
        setProgress(0);
        try {
            const formData = new FormData();
            formData.append("document", file);
            const { data } = await instance.post(routes.uploadDocuments, formData, {
                onUploadProgress: (progressEvent) => {
                    const uploadedBytes = progressEvent.loaded;
                    const percentCompleted = Math.round(
                        (uploadedBytes * 100) / progressEvent.total
                    );

                    setProgress(percentCompleted);
                    setUploadedSize(getFileSize(uploadedBytes));
                },
            });
            if (data) {
                docs[0].isUpload = true;
                docs[0].file = data?.data?.nations;
                setDocumentDetail(docs);
                setDocumentLink(data?.data?.nations);
                SuccessToaster('Document Uploaded')

            }
        } catch (error) {
            ErrorToaster(error);
        }
    };

    const removeDoc = () => {
        try {
            setDocumentDetail([]);
            setDocumentLink("");
            setValue("scanned", "");
        } catch (error) {
            ErrorToaster(error);
        }
    };

    const handleAddDocument = () => {

        if (!documentLink) {
            ErrorToaster("Please upload a document before adding.");
            return;
        }

        if (!selectedIdType) {
            ErrorToaster("Please select document type.");
            return;
        }

        setDocumentList([
            ...documentList,
            {
                id: uuidv4(),
                type: selectedIdType.name,
                expiryDate: documentExpiryDate,
                documentLink,
            },
        ]);
        setSelectedIdType(null);
        setDocumentExpiryDate(new Date());
        setDocumentLink("");
    };

    const getCompanyData = async () => {
        setFetching(true);
        try {
            const { data } = await BuyerServices.getOrganizationData({ org_id: id });
            const filterData = data?.rows?.filter((row) => String(row?.id) === String(id));
            const org = filterData?.[0];

            if (org) {
                setValue("fullName", org.full_e_name || "");
                setValue("shortName", org.short_name || "");
                setValue("masterId", org.master_id || "");
                setValue("masterEmail", org.master_email || "");
                setValue("MasterPassword", org.master_password, { shouldDirty: false });
                setValue("owner", org.owner || "");
                setValue("remark", org.remarks || "");
                setValue("mobileNumber", org.phone || "");

                setCompanyStatus(org.status || "Not Suspend");
                setOrgId(org?.id)

                if (Array.isArray(org?.org_credentials)) {
                    const list = org?.org_credentials.map((c) => {
                        const found = auctionHouses.find((h) => h.id === c.auction_id) || null;
                        // setValue("masterPassword", c?.master_password)
                        setValue("auctionPassword", c?.auction_password)
                        return {
                            id: uuidv4(),
                            auction: found,
                            auction_name: c?.auction_house?.name,
                            auction_id: c.auction_id,
                            master_id: c.master_id,
                            // master_email: c.master_email,
                            // master_password: c.master_password,
                            auction_password: c.auction_password || "",
                            showMaster: false,
                            showAuction: false,

                            canEditMaster: false,
                            canEditAuction: false,

                            _isNew: false,
                            _dirtyMaster: false,
                            _dirtyAuction: false,

                        };
                    });

                    setAuctionCredentials(list);
                }

                if (org?.auction_house?.id) {
                    const match = auctionHouses.find(
                        (h) => h.id === org.auction_house?.id
                    );
                    if (match) {
                        setValue("auctionHouses", match);
                        setSelectedAuctionHouses(match);
                    }
                }
                if (org.expiry_date) setCompanyExpiryDate(new Date(org.expiry_date));

                if (Array.isArray(org.id_types)) {
                    const mapped = org.id_types.map((d) => ({
                        id: d.id || uuidv4(),
                        type: d.type || "",
                        expiryDate: d.expiry_date ? new Date(d.expiry_date) : new Date(),
                        documentLink: d.document_link || "",
                    }));
                    setDocumentList(mapped);
                }

                setCompanyData(org);
            }
        } catch (error) {
            ErrorToaster(error);
        } finally {
            setFetching(false);
        }
    };

    useEffect(() => {
        if (companyData?.auction_house?.id) {
            const match = auctionHouses.find(
                (h) => h.id === companyData?.auction_house?.id
            );
            if (match) {
                setValue("auctionHouses", match);
                setSelectedAuctionHouses(match);
            }

        }
    }, [companyData, auctionHouses, setValue]);

    const updateOrganization = async (formData) => {
        setLoading(true);
        try {
            const documents = documentList.map((doc) => ({
                type: doc.type,
                expiry_date: doc.expiryDate,
                document_link: doc.documentLink,
            }));

            const payload = {
                org_id: orgId,
                full_entity_name: formData.fullName,
                short_name: formData.shortName,
                // master_id: formData.masterId,
                master_email: formData.masterEmail,
                // master_password: formData.MasterPassword,
                owner: formData.owner,
                // auction_id: selectedAuctionHouses?.id,
                expiry_date: companyExpiryDate,
                phone: formData.mobileNumber,
                remarks: formData.remark,
                status: companyStatus,
                documents,
                auction_credentials: auctionCredentials.map((c) => {
                    const base = {
                        auction_id: c.auction_id,
                        master_id: c.master_id,
                        // master_email: c.master_email,
                    };
                    // if (c._isNew || c._dirtyMaster) base.master_password = c.master_password || "";
                    if (c._isNew || c._dirtyAuction) base.auction_password = c.auction_password || "";
                    return base;
                }),
                removed_auction_ids: removedAuctionIds,
            };

            if (dirtyFields?.MasterPassword) {
                payload.master_password = formData?.MasterPassword;
            }
            const { message } = await BuyerServices.updateOrganization(payload);
            navigate('/company-list');
            SuccessToaster(message);
        } catch (error) {
            ErrorToaster(error?.message || error);
        } finally {
            setLoading(false);
        }
    };

    const togglePasswordVisibility = (rowId, which) => {
        setAuctionCredentials((prev) =>
            prev.map((r) => (r.id === rowId ? { ...r, [which]: !r[which] } : r))
        );
    };

    // const updateCredentialField = (rowId, key, value) => {
    //     setAuctionCredentials((prev) =>
    //         prev.map((r) => (r.id === rowId ? { ...r, [key]: value } : r))
    //     );
    // };

    const updateCredentialField = (rowId, key, value, markDirty = true) => {
        setAuctionCredentials((prev) =>
            prev.map((r) => {
                if (r.id !== rowId) return r;
                const next = { ...r, [key]: value };
                if (markDirty) {
                    if (key === "master_password") next._dirtyMaster = true;
                    if (key === "auction_password") next._dirtyAuction = true;
                }
                return next;
            })
        );
    };



    useEffect(() => {
        if (!id) return;
        getCompanyData();
    }, [id]);

    useEffect(() => {
        getAuctionHouses()
    }, []);


    const [openOtpModal, setOpenOtpModal] = useState(false);
    const [requestType, setRequestType] = useState("");

    const [openMasterOtpModal, setOpenMasterOtpModal] = useState(false);
    const [openAuctionOtpModal, setOpenAuctionOtpModal] = useState(false);

    const [passwordMasterType, setPasswordMasterType] = useState("password");
    const [passwordAuctionType, setPasswordAuctionType] = useState("password");

    const [isOtpVerified, setIsOtpVerified] = useState(false);

    const [isOtpSent, setIsOtpSent] = useState(false);
    const [otp, setOtp] = useState(["", "", "", ""]);
    const [otpAuc, setOtpAuc] = useState(["", "", "", ""]);

    const [copiedKey, setCopiedKey] = useState(null);

    const resetMasterOtp = () => {
        console.log("reset master")
        setOtp(["", "", "", ""]);
        setIsOtpSent(false);
        setIsOtpVerified(false);
        setValue("currentRowId", null);
    };

    const resetAuctionOtp = () => {
        console.log("reset auction")
        setOtpAuc(["", "", "", ""]);
        setIsOtpSent(false);
        setIsOtpVerified(false);
        setValue("currentRowIds", null);
    };


    const copyToClipboard = async (text, key) => {
        try {
            await navigator.clipboard.writeText(text || '');
            setCopiedKey(key);
            SuccessToaster('Copied!');
            setTimeout(() => setCopiedKey(null), 1200);
        } catch (e) {
            ErrorToaster('Copy failed');
        }
    };

    const handleOtpChange = (value, index) => {
        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        if (value && index < 3) {
            document.getElementById(`otp-master-${index + 1}`).focus();
        }
    };

    const handleOtpFocus = (index) => {
        if (otp[index]) {
            document.getElementById(`otp-master-${index}`).select();
        }
    };

    const handleOtpChangeAuc = (value, index) => {
        const newOtp = [...otpAuc];
        newOtp[index] = value;
        setOtpAuc(newOtp);

        if (value && index < 3) {
            document.getElementById(`otp-auction-${index + 1}`).focus();
        }
    };

    const handleOtpFocusAuc = (index) => {
        if (otpAuc[index]) {
            document.getElementById(`otp-auction-${index}`).select();
        }
    };


    const handleMasterToggle = async () => {
        try {
            const response = await BuyerServices.sendOrgOtpForPasswordVerification({ user_id: user?.id, master_email: companyData?.master_email });
            if (response?.message) {
                SuccessToaster("OTP is send to your email and number");
                resetMasterOtp();
                setOpenMasterOtpModal(true);
                setIsOtpSent(true);
                // setValue("currentRowId", row.id);
            }
        } catch (error) {
            ErrorToaster(error);
        }
    };

    const handleAuctionPasswordToggle = async (row) => {
        try {
            const response = await BuyerServices.sendOrgOtpForPasswordVerification({ user_id: user?.id, master_id: row?.master_id });
            if (response?.message) {
                SuccessToaster("OTP is send to your email and number");
                resetAuctionOtp();
                setOpenAuctionOtpModal(true);
                setIsOtpSent(true);
                setValue("currentRowIds", row.id);

            }
        } catch (error) {
            ErrorToaster(error);
        }
    };

    // add near top with other useState
    const [showAddMasterPwd, setShowAddMasterPwd] = useState(false);
    const [showAddAuctionPwd, setShowAddAuctionPwd] = useState(false);


    const handleOtpKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            e.preventDefault();
            setOtp((prevOtp) => {
                const newOtp = [...prevOtp];
                if (newOtp[index]) {
                    newOtp[index] = "";
                } else if (index > 0) {
                    newOtp[index - 1] = "";
                    document.getElementById(`otp-master-${index - 1}`).focus();
                }
                return newOtp;
            });
        }
    };

    const handleOtpKeyDownAuc = (e, index) => {
        if (e.key === "Backspace") {
            e.preventDefault();
            setOtpAuc((prev) => {
                const next = [...prev];
                if (next[index]) {
                    next[index] = "";
                } else if (index > 0) {
                    next[index - 1] = "";
                    document.getElementById(`otp-auction-${index - 1}`)?.focus();
                }
                return next;
            });
        }
    };



    const handleMasterOtpVerification = async () => {
        try {
            const otpString = otp.join('');
            const rowId = getValues("currentRowId");
            const currentRow = auctionCredentials.find(r => r.id === rowId);

            let obj = {
                otp: otpString,
                user_id: user?.id,
                master_email: companyData?.master_email,
            };

            const response = await BuyerServices.verifyOrgOTP(obj);
            setValue('MasterPassword', response?.data?.password, { shouldDirty: false });

            if (response?.status) {
                SuccessToaster("OTP Verified!");
                // const decrypted = response?.data?.password || "";
                // updateCredentialField(rowId, "master_password", decrypted, false);

                // setAuctionCredentials(prev =>
                //     prev.map(r => r.id === rowId ? { ...r, master_password: decrypted, showMaster: true, canEditMaster: true } : r)
                // );

                setOtp(["", "", "", ""]);
                setIsOtpVerified(true);
                setPasswordMasterType("text");
                setOpenMasterOtpModal(false);
                resetMasterOtp();
            } else {
                ErrorToaster("Invalid OTP");
            }
        } catch (error) {
            ErrorToaster(error);
        }
    };



    const handleAuctionOtpVerification = async () => {
        try {
            const otpString = otpAuc.join('');
            const rowId = getValues("currentRowIds");
            const currentRow = auctionCredentials.find(r => r.id === rowId);

            let obj = {
                otp: otpString,
                user_id: user?.id,
                master_id: currentRow.master_id,
            };

            const response = await BuyerServices.verifyOrgOTP(obj);
            setValue('masterPassword', response?.data?.password);
            if (response?.status) {
                SuccessToaster("OTP Verified!");
                const decrypted = response?.data?.password || "";
                updateCredentialField(rowId, "auction_password", decrypted, false);
                setAuctionCredentials(prev =>
                    prev.map(r => r.id === rowId ? { ...r, auction_password: decrypted, showAuction: true, canEditAuction: true } : r)
                );

                setIsOtpVerified(true);
                setPasswordAuctionType("text");
                setOpenAuctionOtpModal(false);
                resetAuctionOtp();
            } else {
                ErrorToaster("Invalid OTP");
            }
        } catch (error) {
            ErrorToaster(error);
        }
    };


    const EDITOR_IDS = new Set([42410, 56743, 56197, 50917]);

    const isEditAllowed = EDITOR_IDS.has(Number(user?.id));

    // const isEditAllowed = user?.id === 42410;

    const [canEdit, setCanEdit] = useState(false);

    const formDisabled = !canEdit;

    const isMAsterPwdEditable = passwordMasterType === "text";

    const handleDeleteDocument = (rowId) => {
        setDocumentList((prev) => prev.filter((d) => d.id !== rowId));
    };

    return (
        <>
            <Dialog open={openAuctionOtpModal} onClose={() => { setOpenAuctionOtpModal(false); resetAuctionOtp(); }} sx={{ padding: 4 }}>
                <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                    Enter OTP
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 0.5 }}>
                        {otpAuc.map((digit, index) => (
                            <input
                                key={index}
                                id={`otp-auction-${index}`}
                                value={digit}
                                onChange={(e) => handleOtpChangeAuc(e.target.value, index)}
                                onFocus={() => handleOtpFocusAuc(index)}
                                maxLength={1}
                                type="text"
                                onKeyDown={(e) => handleOtpKeyDownAuc(e, index)}
                                style={{
                                    width: "50px",
                                    height: "50px",
                                    fontSize: "20px",
                                    backgroundColor: '#f4f4f4',
                                    borderRadius: '8px',
                                    border: `1px solid ${Colors.primary}`,
                                    marginRight: '8px',
                                    outline: 'none',
                                    textAlign: 'center',
                                    color: Colors.textSecondary
                                }}
                            />
                        ))}
                    </Box>
                    <Typography variant="body2" sx={{ textAlign: 'center', mt: 0.9, color: Colors.smokeyGrey }}>
                        Enter the 4-digit code sent to your mobile or email.
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'center', padding: '16px' }}>
                    <PrimaryButton
                        title="Verify OTP"
                        onClick={handleAuctionOtpVerification}
                        style={{
                            fontSize: 14,
                            borderRadius: '14px',
                            // width: '180px',
                            backgroundColor: Colors.primary,
                            color: 'white',
                            textTransform: 'none'
                        }}
                    />
                </DialogActions>
            </Dialog>


            <Dialog open={openMasterOtpModal} onClose={() => { setOpenMasterOtpModal(false); resetMasterOtp(); }} sx={{ padding: 4 }}>
                <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                    Enter OTP
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 0.5 }}>
                        {otp.map((digit, index) => (
                            <input
                                key={index}
                                id={`otp-master-${index}`}
                                value={digit}
                                onChange={(e) => handleOtpChange(e.target.value, index)}
                                onFocus={() => handleOtpFocus(index)}
                                maxLength={1}
                                type="text"
                                onKeyDown={(e) => handleOtpKeyDown(e, index)}
                                style={{
                                    width: "50px",
                                    height: "50px",
                                    fontSize: "20px",
                                    backgroundColor: '#f4f4f4',
                                    borderRadius: '8px',
                                    border: `1px solid ${Colors.primary}`,
                                    marginRight: '8px',
                                    outline: 'none',
                                    textAlign: 'center',
                                    color: Colors.textSecondary
                                }}
                            />
                        ))}
                    </Box>
                    <Typography variant="body2" sx={{ textAlign: 'center', mt: 0.9, color: Colors.smokeyGrey }}>
                        Enter the 4-digit code sent to your mobile or email.
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'center', padding: '16px' }}>
                    <PrimaryButton
                        title="Verify OTP"
                        onClick={handleMasterOtpVerification}
                        style={{
                            fontSize: 14,
                            borderRadius: '14px',
                            // width: '180px',
                            backgroundColor: Colors.primary,
                            color: 'white',
                            textTransform: 'none'
                        }}
                    />
                </DialogActions>
            </Dialog>


            <Box
                sx={{
                    m: 4,
                    p: 5,
                    bgcolor: Colors.white,
                    borderRadius: 3,
                    boxShadow: "0px 8px 18px 0px #9B9B9B1A",
                }}
            >

                <Box component="form" onSubmit={handleSubmit(updateOrganization)}>
                    <Grid container spacing={2}>

                        <Grid item xs={12} sm={12}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 4 }}>
                                <Typography
                                    variant="h5"
                                    sx={{ color: Colors.charcoalGrey, fontFamily: FontFamily.NunitoRegular }}
                                >
                                    Update Company
                                </Typography>
                                <PrimaryButton
                                    title="Edit"
                                    onClick={() => setCanEdit(true)}
                                    disabled={!isEditAllowed}
                                    style={{
                                        backgroundColor: isEditAllowed ? Colors.primary : '#bdbdbd',
                                        color: Colors.white,
                                        cursor: isEditAllowed ? 'pointer' : 'not-allowed',
                                    }}
                                />
                            </Box>
                        </Grid>

                        <Grid item xs={12} sm={12}>
                            <InputField
                                size={"small"}
                                label={"Full Entity Name"}
                                placeholder={"Full Entity Name"}
                                disabled={formDisabled}
                                error={errors?.fullName?.message}
                                register={register("fullName", {
                                    required: 'Please Enter Full Name.',
                                })}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <InputField
                                size={"small"}
                                label={"Short Name"}
                                placeholder={"Short Name"}
                                disabled={formDisabled}
                                error={errors?.shortName?.message}
                                register={register("shortName", {
                                    required: 'Please Enter Short Name.',
                                })}
                            />
                        </Grid>


                        <Grid item xs={12} sm={4}>
                            <InputField
                                size={"small"}
                                label={"Master Email"}
                                type="email"
                                placeholder={"Master Email"}
                                disabled={formDisabled}
                                error={errors?.masterEmail?.message}

                                register={register("masterEmail", {
                                    required: "Please enter your email.",
                                    pattern: {
                                        value: emailRegex,
                                        message: "Please enter a valid email.",
                                    },
                                })}
                            />
                        </Grid>

                        <Grid item xs={12} sm={4}>

                            <InputField
                                size={"small"}
                                label={"Master Email Password"}
                                placeholder={"Master Email Password"}
                                type={showMasterPassword ? "text" : passwordMasterType}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end" sx={{ gap: 0.5 }}>

                                            {passwordMasterType === "text" && (
                                                <IconButton
                                                    edge="end"
                                                    size="small"
                                                    onClick={() => copyToClipboard(getValues('MasterPassword'), 'MasterPassword')}
                                                    aria-label="Copy master password"
                                                >
                                                    {copiedKey === 'MasterPassword' ? <Check sx={{ fontSize: 18 }} /> : <ContentCopy sx={{ fontSize: 18 }} />}
                                                </IconButton>
                                            )}

                                            <IconButton
                                                edge="end"
                                                onClick={() => handleMasterToggle()}
                                            >
                                                {showMasterPassword ? (
                                                    <Visibility sx={{ fontSize: 24 }} color="primary" />
                                                ) : (
                                                    <VisibilityOff sx={{ fontSize: 24 }} color="primary" />
                                                )}
                                            </IconButton>


                                        </InputAdornment>
                                    ),
                                }}
                                inputProps={{ readOnly: !isMAsterPwdEditable, autoComplete: "new-password" }}
                                error={errors?.MasterPassword?.message}
                                register={register("MasterPassword", {
                                    required: "Please enter the password.",
                                })}
                                disabled={formDisabled}
                            />

                        </Grid>

                        {/* <Grid item xs={12} sm={4}>
                        <InputField
                            size={"small"}
                            label={"Master ID"}
                            placeholder={"Master ID"}
                            register={register("masterId")}
                        />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <InputField
                            size={"small"}
                            label={"Master Email"}
                            type="email"
                            placeholder={"Master Email"}
                            register={register("masterEmail", {
                                // required: "Please enter your email.",
                                pattern: {
                                    value: emailRegex,
                                    message: "Please enter a valid email.",
                                },
                            })}
                        />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <InputField
                            size={"small"}
                            label={"Master ID Password"}
                            placeholder={"Master ID Password"}
                            type={showMasterPassword ? "text" : "password"}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            edge="end"
                                            onClick={() => setShowMasterPassword(!showMasterPassword)}
                                        >
                                            {showMasterPassword ? (
                                                <Visibility color="primary" />
                                            ) : (
                                                <VisibilityOff color="primary" />
                                            )}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}

                            register={register("MasterPassword", {
                                // required: "Please select ID Type.",
                            })}
                        />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <SelectField
                            onSearch={(v) => getAuctionHouses(v)}
                            label={'Auctions Houses'}
                            options={auctionHouses}
                            selected={selectedAuctionHouses}
                            onSelect={(value) => setSelectedAuctionHouses(value)}
                            error={errors?.auctionHouses?.message}
                            register={register("auctionHouses", {
                                required: 'Please select auction house.',
                            })}
                        />
                    </Grid> */}



                        <Grid item xs={12} sm={4}>
                            <InputField
                                size={"small"}
                                label={"Owner"}
                                placeholder={"Owner"}
                                disabled={formDisabled}
                                error={errors?.owner?.message}
                                register={register("owner", {
                                    required: 'Please Enter Owner.',
                                })}
                            />
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <DatePicker
                                size={"small"}
                                label={"Company Expiry Date"}
                                value={companyExpiryDate}
                                onChange={(date) => handleCompanyExpiryDate(date)}
                            />
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <InputPhone
                                label={"Mobile Number For OTP"}
                                name={"mobileNumber"}
                                control={control}
                                borderRadius="12px"
                                size='small'
                                height='45px'
                                rules={{
                                    required:
                                        "Please enter your international mobile number.",
                                }}
                                error={errors?.mobileNumber?.message}
                                register={register("mobileNumber", {
                                    required: 'Please Enter Moile Number.',
                                })}
                                disabled={formDisabled}

                            />
                        </Grid>


                        <Grid item xs={12} sm={4}>
                            <InputField
                                size={"small"}
                                label={"Remarks"}
                                placeholder={"Remarks"}
                                register={register("remark")}
                                disabled={formDisabled}
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <Typography
                                variant="subtitle1"
                                sx={{
                                    color: Colors.charcoalGrey,
                                    fontFamily: FontFamily.NunitoRegular,
                                }}
                            >
                                Status
                            </Typography>
                            <FormControl disabled={formDisabled}>
                                <RadioGroup
                                    row
                                    value={companyStatus}
                                    onChange={(e) => setCompanyStatus(e.target.value)}
                                >

                                    <span style={{ display: "inline-block" }}>
                                        <FormControlLabel
                                            value="Suspend"
                                            control={<Radio />}
                                            label="Suspend"

                                        />
                                    </span>
                                    <FormControlLabel
                                        value="Not Suspend"
                                        control={<Radio />}
                                        label="Not Suspend"
                                    />
                                </RadioGroup>
                            </FormControl>
                        </Grid>


                        {/* ===== Auction Credentials (repeatable) ===== */}
                        <Grid container spacing={2} padding={2} sx={{ mt: 1 }}>
                            {/* <Grid item xs={12}>
                            <Typography
                                variant="subtitle1"
                                sx={{ color: Colors.charcoalGrey, fontFamily: FontFamily.NunitoRegular, mb: 1 }}
                            >
                                Auction Credentials
                            </Typography>
                        </Grid> */}

                            {/* Auction House (select) */}
                            <Grid item xs={12} sm={3}>
                                <SelectField
                                    onSearch={(v) => getAuctionHouses(v)}
                                    label={'Auction House'}
                                    options={auctionHouses}
                                    selected={credAuctionHouse}
                                    onSelect={(value) => setCredAuctionHouse(value)}
                                    disabled={formDisabled}
                                />
                            </Grid>

                            {/* Master ID */}
                            <Grid item xs={12} sm={3}>
                                <InputField
                                    size="small"
                                    label="Auction Master ID"
                                    placeholder="Auction Master ID"
                                    value={credMasterId}
                                    onChange={(e) => setCredMasterId(e.target.value)}
                                    disabled={formDisabled}
                                />
                            </Grid>

                            {/* <Grid item xs={12} sm={3}>
                                <InputField
                                    size="small"
                                    label="Master Email"
                                    type="email"
                                    placeholder="Master Email"
                                    value={credMasterEmail}
                                    onChange={(e) => setCredMasterEmail(e.target.value)}
                                    disabled={formDisabled}
                                />
                            </Grid>

                            <Grid item xs={12} sm={3}>
                                <InputField
                                    size="small"
                                    label="Master Password"
                                    placeholder="Master Password"
                                    type={showAddMasterPwd ? "text" : "password"}
                                    value={credMasterPassword}
                                    onChange={(e) => setCredMasterPassword(e.target.value)}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton edge="end" onClick={() => setShowAddMasterPwd(v => !v)}>
                                                    {showAddMasterPwd ? <Visibility color="primary" /> : <VisibilityOff color="primary" />}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                    disabled={formDisabled}
                                />

                            </Grid> */}

                            {/* Auction Password */}
                            <Grid item xs={12} sm={3}>
                                <InputField
                                    size="small"
                                    label="Auction Master Password"
                                    placeholder="Auction Master Password"
                                    type={showAddAuctionPwd ? "text" : "password"}
                                    value={credAuctionPassword}
                                    onChange={(e) => setCredAuctionPassword(e.target.value)}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton edge="end" onClick={() => setShowAddAuctionPwd(v => !v)}>
                                                    {showAddAuctionPwd ? <Visibility color="primary" /> : <VisibilityOff color="primary" />}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                    disabled={formDisabled}
                                />

                                {/* <InputField
                                    size="small"
                                    label="Auction Password"
                                    placeholder="Auction Password"
                                    value={credAuctionPassword}
                                    type={showAuctionPassword ? "text" : "password"}
                                    onChange={(e) => setCredAuctionPassword(e.target.value)}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton edge="end" onClick={() => setShowAuctionPassword(!showAuctionPassword)}>
                                                    {showAuctionPassword ? <Visibility color="primary" /> : <VisibilityOff color="primary" />}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                /> */}
                            </Grid>

                            {/* Add button */}
                            <Grid item xs={12} sm={2} sx={{ textAlign: "right" }} mt={4}>

                                <PrimaryButton
                                    title={"Link Auction House"}
                                    startIcon={<Add sx={{ color: Colors.white }} />}
                                    onClick={addAuctionCredential}
                                />
                                {/* <IconButton
                                    size="small"
                                    onClick={addAuctionCredential}
                                    sx={{
                                        bgcolor: Colors.primary,
                                        color: Colors.white,
                                        "&:hover": { bgcolor: Colors.primary, color: Colors.white },
                                    }}
                                >
                                    <Add />
                                </IconButton> */}
                            </Grid>

                            {/* List (table) */}
                            {auctionCredentials.length > 0 && (
                                <Grid item xs={12}>
                                    <TableContainer component={Paper}>
                                        <Table sx={{ minWidth: 650 }} aria-label="Auction Credentials Table">
                                            <TableHead sx={{ bgcolor: Colors.primary, color: Colors.white }}>
                                                <TableRow>
                                                    <Cell>Auction House</Cell>
                                                    <Cell>Auction Master ID</Cell>
                                                    {/* <Cell>Master Email</Cell>
                                                    <Cell>Master Password</Cell> */}
                                                    <Cell sx={{ width: 300, minWidth: 300 }}>Auction Master Password</Cell>
                                                    <Cell>Action</Cell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {auctionCredentials.map((row) => (
                                                    <TableRow key={row.id}>
                                                        <TableCell>{row?.auction_name || row?.auction?.name}</TableCell>
                                                        <TableCell>{row?.master_id}</TableCell>
                                                        {/* <TableCell>{row?.master_email}</TableCell> */}
                                                        {/* <TableCell>
                                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>

                                                                {companyData?.org_credentials?.[0]?.auction_password_auth_tag ? (
                                                                    <>
                                                                        <InputField
                                                                            size="small"
                                                                            placeholder="Master Password"
                                                                            type={row.showMaster ? "text" : "password"}
                                                                            value={row.master_password || ""}
                                                                            onChange={(e) =>
                                                                                updateCredentialField(row.id, "master_password", e.target.value)
                                                                            }
                                                                            disabled={!row.canEditMaster}
                                                                            InputProps={{
                                                                                endAdornment: (
                                                                                    <InputAdornment position="end" sx={{ gap: 0.5 }}>
                                                                                        <IconButton
                                                                                            edge="end"
                                                                                            onClick={() => handleMasterToggle(row)}
                                                                                        >
                                                                                            {row.showMaster ? <Visibility color="primary" /> : <VisibilityOff color="primary" />}
                                                                                        </IconButton>
                                                                                        {row.showAuction && (
                                                                                            <IconButton
                                                                                                edge="end"
                                                                                                size="small"
                                                                                                onClick={() => copyToClipboard(row.master_password, 'masterPassword')}
                                                                                                aria-label="Copy master password"
                                                                                            >
                                                                                                {copiedKey === 'masterPassword' ? <Check /> : <ContentCopy />}
                                                                                            </IconButton>
                                                                                        )}
                                                                                    </InputAdornment>
                                                                                ),
                                                                            }}
                                                                        />
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        {row.showMaster ? (
                                                                            <InputField
                                                                                size="small"
                                                                                placeholder="Master Password"
                                                                                type="text"
                                                                                value={row.master_password || ""}
                                                                                onChange={(e) =>
                                                                                    updateCredentialField(row.id, "master_password", e.target.value)
                                                                                }
                                                                                sx={{ minWidth: 100 }}
                                                                            />
                                                                        ) : (
                                                                            <Typography>{row.master_password ? "••••••••" : ""}</Typography>
                                                                        )}
                                                                        <IconButton onClick={() => togglePasswordVisibility(row.id, "showMaster")} size="small">
                                                                            {row.showMaster ? <Visibility color="primary" /> : <VisibilityOff color="primary" />}
                                                                        </IconButton>


                                                                    </>
                                                                )

                                                                }
                                                            </Box>
                                                        </TableCell> */}


                                                        <TableCell sx={{ width: 300, minWidth: 300 }}>
                                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>

                                                                {companyData?.org_credentials?.[0]?.auction_password_auth_tag ? (
                                                                    <>
                                                                        <InputField
                                                                            size="small"
                                                                            placeholder="Auction Password"
                                                                            type={row.showAuction ? "text" : "password"}
                                                                            value={row.auction_password || ""}
                                                                            onChange={(e) =>
                                                                                updateCredentialField(row.id, "auction_password", e.target.value)
                                                                            }
                                                                            disabled={!row.canEditAuction}
                                                                            sx={{
                                                                                minWidth: 120,
                                                                            }}
                                                                            InputProps={{
                                                                                endAdornment: (
                                                                                    <InputAdornment position="end" sx={{ gap: 0.5 }}>

                                                                                        {row.showAuction && (
                                                                                            <IconButton
                                                                                                edge="end"
                                                                                                size="small"
                                                                                                onClick={() => copyToClipboard(row.auction_password, 'auctionPassword')}
                                                                                                aria-label="Copy auction password"
                                                                                            >
                                                                                                {copiedKey === 'auctionPassword' ? <Check /> : <ContentCopy />}
                                                                                            </IconButton>
                                                                                        )}

                                                                                        <IconButton
                                                                                            edge="end"
                                                                                            onClick={() => handleAuctionPasswordToggle(row)}
                                                                                        >
                                                                                            {row.showAuction ? <Visibility color="primary" /> : <VisibilityOff color="primary" />}
                                                                                        </IconButton>

                                                                                    </InputAdornment>
                                                                                ),
                                                                            }}

                                                                        />
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        {row.showAuction ? (
                                                                            <InputField
                                                                                size="small"
                                                                                placeholder="Auction Password"
                                                                                type="text"
                                                                                value={row.auction_password || ""}
                                                                                onChange={(e) =>
                                                                                    updateCredentialField(row.id, "auction_password", e.target.value)
                                                                                }
                                                                                sx={{ minWidth: 100 }}
                                                                            />
                                                                        ) : (
                                                                            <Typography>{row.auction_password ? "••••••••" : ""}</Typography>
                                                                        )}
                                                                        <IconButton onClick={() => togglePasswordVisibility(row.id, "showAuction")} size="small">
                                                                            {row.showAuction ? <Visibility color="primary" /> : <VisibilityOff color="primary" />}
                                                                        </IconButton>
                                                                    </>
                                                                )}

                                                            </Box>
                                                        </TableCell>

                                                        <TableCell>
                                                            <IconButton sx={{ p: '8px' }} onClick={() => removeAuctionCredential(row.id)}>
                                                                <DeleteIcon
                                                                    sx={{
                                                                        fontSize: '18px',
                                                                        color: Colors.danger,
                                                                    }}
                                                                />
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            )}
                        </Grid>


                        <Grid container spacing={2} padding={2}>
                            <Grid item xs={12} sm={3.5}>
                                <SelectField
                                    label="Document Type"
                                    options={IDTYPES}
                                    selected={selectedIdType}
                                    onSelect={(value) => setSelectedIdType(value)}
                                    disabled={formDisabled}
                                />
                            </Grid>

                            <Grid item xs={12} sm={3.5}>
                                <DatePicker
                                    label="Document Expiry Date"
                                    value={documentExpiryDate}
                                    onChange={(date) => handleDocumentExpiryDate(date)}
                                />
                            </Grid>

                            <Grid item xs={12} sm={3.5} mt={3.7}>
                                <UploadFile
                                    custom={true}
                                    style={{
                                        backgroundColor: "#e7efeb",
                                        width: "100%",
                                        height: "40px",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        padding: "20px",
                                        border: "1px dashed #aeb1b0",
                                        borderRadius: "10px",
                                    }}
                                    register={register("scanned", {
                                        onChange: (e) => handleUploadDocument(e),
                                    })}
                                />
                            </Grid>

                            {/* <Grid item xs={12} sm={4}>
                        {documentDetail.length > 0 && (
                            <Typography
                                variant="body1"
                                sx={{ color: Colors.charcoalGrey, mb: 1 }}
                            >
                                Uploaded Files
                            </Typography>
                        )}
                        <Box sx={{ maxHeight: 300, overflow: "auto", pr: 1 }}>
                            {documentDetail?.map((item, index) => (
                                <Uploading
                                    key={index}
                                    data={item}
                                    uploadedSize={uploadedSize}
                                    progress={progress}
                                    removeDoc={() => removeDoc()}
                                />
                            ))}
                        </Box> 
                    </Grid> */}

                            <Grid item xs={12} sm={1} sx={{ textAlign: "right" }} mt={4}>
                                <IconButton
                                    size="small"
                                    onClick={handleAddDocument}
                                    sx={{
                                        bgcolor: Colors.primary,
                                        color: Colors.white,
                                        "&:hover": {
                                            bgcolor: Colors.primary,
                                            color: Colors.white,
                                        },
                                    }}
                                >
                                    <Add />
                                </IconButton>
                            </Grid>


                            {
                                documentList.length > 0 ? (
                                    <>
                                        <Grid item xs={12} sm={12}>
                                            <TableContainer component={Paper}>
                                                <Table sx={{ minWidth: 650 }} aria-label="Documents Table">
                                                    <TableHead sx={{ bgcolor: Colors.primary, color: Colors.white }}>
                                                        <TableRow>
                                                            <Cell>Document Type</Cell>
                                                            <Cell>Expiry Date</Cell>
                                                            <Cell>Attachment</Cell>
                                                            <Cell>Action</Cell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {documentList.map((doc) => (
                                                            <TableRow key={doc?.id}>
                                                                <TableCell>{doc?.type}</TableCell>
                                                                <TableCell>{new Date(doc?.expiryDate).toLocaleDateString()}</TableCell>
                                                                <TableCell>

                                                                    {doc?.documentLink && doc?.documentLink ? (
                                                                        <div style={{ cursor: "pointer" }} onClick={() => downloadAllAttachments(doc?.documentLink)}>
                                                                            <FiDownload color={Colors.primary} size={25} />
                                                                        </div>
                                                                    ) : (
                                                                        <FiDownload color="gray" size={25} />
                                                                    )}
                                                                </TableCell>
                                                                <TableCell>
                                                                    <IconButton
                                                                        aria-label="delete document"
                                                                        onClick={() => handleDeleteDocument(doc.id)}
                                                                        sx={{ p: "8px" }}
                                                                    >
                                                                        <DeleteIcon sx={{ fontSize: 18, color: Colors?.danger}} />
                                                                    </IconButton>
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Grid>

                                    </>
                                ) : (
                                    <>
                                    </>
                                )
                            }
                        </Grid>

                        <Grid item xs={12} sm={12} sx={{ mt: 2, textAlign: "right" }}>
                            <PrimaryButton title="Update" type="submit" loading={loading} />
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </>
    );
}

export default UpdateCompany;
